import React from 'react';
import { Script } from 'gatsby';
import MuiWrapper from './muiwrapper';

const GTM_ID = 'GTM-KSWKXST';

export const wrapRootElement = ({ element }) => {
  return (
    <MuiWrapper>
      {element}
      <Script
        id="gtm"
        strategy="off-main-thread"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `,
        }}
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" title="google tag manager"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
    </MuiWrapper>
  );
};
